export default __webpack_public_path__ + "static/media/DSC00380.ea09816d.JPG";